module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/VG-418e03262358213cbc64551127725d68.png";